import { useMemo } from 'react';
import useFieldValidation from 'hooks/useFieldValidation';
function getValidatedFields(nameAutoCalculationMethod) {
    const nameField = nameAutoCalculationMethod ? 'properName' : 'name';
    return [nameField, 'categoryObj', 'orderOperatorObj', 'supplierObj', 'productDescription'];
}
function getFieldLabel(name, t) {
    switch (name) {
        case 'name':
        case 'properName':
            return t('common:name');
        case 'categoryObj':
            return t('specification:category');
        case 'orderOperatorObj':
            return t('orderOperators:order_operator_capitalize');
        case 'supplierObj':
            return t('specification:supplier');
        case 'productDescription':
            return t('specification:description');
        default:
            return name;
    }
}
function getFieldError(name, productForm, t) {
    var _a, _b, _c, _d, _e;
    switch (name) {
        case 'name':
            return !((_a = productForm.name) === null || _a === void 0 ? void 0 : _a.trim()) ? t('specification:required_field') : null;
        case 'properName':
            return !((_b = productForm.properName) === null || _b === void 0 ? void 0 : _b.trim()) ? t('specification:required_field') : null;
        case 'categoryObj':
            return !((_c = productForm.categoryObj) === null || _c === void 0 ? void 0 : _c.id) ? t('specification:required_field') : null;
        case 'orderOperatorObj':
            return !((_d = productForm.orderOperatorObj) === null || _d === void 0 ? void 0 : _d.id) ? t('specification:required_field') : null;
        case 'supplierObj':
            return !((_e = productForm.supplierObj) === null || _e === void 0 ? void 0 : _e.id) ? t('specification:required_field') : null;
        case 'productDescription': {
            const desc = productForm.productDescription || '';
            return desc.length > 0 && desc.length < 5 ? t('specification:description_min_5_chars') : null;
        }
        default:
            return null;
    }
}
function useComponentValidation(productForm, t) {
    var _a;
    const nameAutoCalculationMethod = (_a = productForm === null || productForm === void 0 ? void 0 : productForm.categoryObj) === null || _a === void 0 ? void 0 : _a.nameAutoCalculationMethod;
    const validatedFields = useMemo(() => getValidatedFields(nameAutoCalculationMethod), [nameAutoCalculationMethod]);
    return useFieldValidation(validatedFields, (field) => getFieldError(field, productForm, t), (field) => getFieldLabel(field, t));
}
export default useComponentValidation;
